export const convertUrlSearchParamsToObject = (searchParams) => {
    let obj = {};
    searchParams.forEach((value, key) => {
        obj[key] = value;
    });
    return obj;
}